var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryGamer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 12@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-841.000000, -890.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.000000, 207.000000)",
    id: "gaming-controller"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.17777778,2.84426677 C7.98143854,2.84426677 7.82222222,2.68508437 7.82222222,2.48871122 L7.82222222,0.355377707 C7.82222222,0.15904 7.98143854,-0.000177848889 8.17777778,-0.000177848889 C8.37411431,-0.000177848889 8.53333333,0.15904 8.53333333,0.355377707 L8.53333333,2.48871122 C8.53333333,2.68508437 8.37411431,2.84426677 8.17777778,2.84426677 Z",
    id: "Path",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,10.6666667 L6.75555556,10.6666667 C6.55921632,10.6666667 6.4,10.507449 6.4,10.3111111 C6.4,10.1147732 6.55921632,9.95555556 6.75555556,9.95555556 L9.6,9.95555556 C9.79633653,9.95555556 9.95555556,10.1147732 9.95555556,10.3111111 C9.95555556,10.507449 9.79633653,10.6666667 9.6,10.6666667 Z",
    id: "Path",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9787367,12.6824531 L14.5809774,5.69376018 C14.3330824,4.45450642 13.2358385,3.55502219 11.9721232,3.55502219 C11.2613675,3.55502219 10.4406738,3.9650133 10.090701,4.33436416 C9.7407274,4.7037157 9.6,4.97777778 9.6,4.97777778 L6.75555556,4.97777778 C6.75555556,4.97777778 6.68774958,4.82428452 6.25496757,4.33436416 C5.82222222,3.84444444 5.08430073,3.55502219 4.37354532,3.55502219 C3.10982969,3.55502219 2.01258542,4.45450645 1.76469198,5.69376018 L0.366933369,12.6824531 C0.279429938,13.1197862 0.466772124,13.5560886 0.844016533,13.7939196 C1.22161664,14.0317871 1.69610546,14.0126574 2.05304772,13.7449599 L4.97777778,11.3777778 L11.3777778,11.3777778 L14.2927979,13.7451375 C14.4832343,13.8878581 14.7071995,13.9598931 14.9318739,13.9598931 C15.1283895,13.9598931 15.3256158,13.904853 15.501652,13.7939195 C15.8788967,13.5560886 16.0662381,13.1197862 15.9787367,12.6824531 Z",
    id: "Path",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6D6D6D",
    cx: 5.33333333,
    cy: 10.3105781,
    r: 1.42222222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,12.0883558 C4.35313653,12.0883558 3.55555556,11.2908095 3.55555556,10.3105781 C3.55555556,9.33038194 4.35313653,8.53280028 5.33333333,8.53280028 C6.31352743,8.53280028 7.11111111,9.33038194 7.11111111,10.3105781 C7.11111111,11.2908095 6.31352743,12.0883558 5.33333333,12.0883558 Z M5.33333333,9.2439114 C4.7451365,9.2439114 4.26666667,9.72238226 4.26666667,10.3105781 C4.26666667,10.8987739 4.7451365,11.3772447 5.33333333,11.3772447 C5.92152779,11.3772447 6.4,10.8987739 6.4,10.3105781 C6.4,9.72238226 5.92152779,9.2439114 5.33333333,9.2439114 Z",
    id: "Shape",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6D6D6D",
    cx: 11.0222222,
    cy: 10.3105781,
    r: 1.42222222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0222222,12.0883558 C10.0420254,12.0883558 9.24444444,11.2908095 9.24444444,10.3105781 C9.24444444,9.33038194 10.0420254,8.53280028 11.0222222,8.53280028 C12.0024156,8.53280028 12.8,9.33038194 12.8,10.3105781 C12.8,11.2908095 12.0024156,12.0883558 11.0222222,12.0883558 Z M11.0222222,9.2439114 C10.4340251,9.2439114 9.95555556,9.72238226 9.95555556,10.3105781 C9.95555556,10.8987739 10.4340251,11.3772447 11.0222222,11.3772447 C11.6104167,11.3772447 12.0888889,10.8987739 12.0888889,10.3105781 C12.0888889,9.72238226 11.6104167,9.2439114 11.0222222,9.2439114 Z",
    id: "Shape",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3B3B3",
    x: 7.46666667,
    y: 2.13333333,
    width: 1.42222222,
    height: 2.84444444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,7.11111111 L5.68888889,7.11111111 C5.88526069,7.11111111 6.04444444,6.95192871 6.04444444,6.75555556 L6.04444444,6.4 C6.04444444,6.20362684 5.88526069,6.04444444 5.68888889,6.04444444 L5.33333333,6.04444444 C5.13695883,6.04444444 4.97777778,6.20362684 4.97777778,6.4 L4.97777778,6.75555556 C4.97777778,6.95192871 5.13695883,7.11111111 5.33333333,7.11111111 Z",
    id: "Path",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2,7.11111111 L3.55555556,7.11111111 C3.75192768,7.11111111 3.91111111,6.95192871 3.91111111,6.75555556 L3.91111111,6.4 C3.91111111,6.20362684 3.75192768,6.04444444 3.55555556,6.04444444 L3.2,6.04444444 C3.00362549,6.04444444 2.84444444,6.20362684 2.84444444,6.4 L2.84444444,6.75555556 C2.84444444,6.95192871 3.00362549,7.11111111 3.2,7.11111111 Z",
    id: "Path",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91111111,7.46666667 L3.91111111,7.82222222 C3.91111111,8.01859538 4.07029216,8.17777778 4.26666667,8.17777778 L4.62222222,8.17777778 C4.81859435,8.17777778 4.97777778,8.01859538 4.97777778,7.82222222 L4.97777778,7.46666667 C4.97777778,7.27029351 4.81859435,7.11111111 4.62222222,7.11111111 L4.26666667,7.11111111 C4.07029216,7.11111111 3.91111111,7.27029351 3.91111111,7.46666667 Z",
    id: "Path",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91111111,5.33333333 L3.91111111,5.68888889 C3.91111111,5.88526204 4.07029216,6.04444444 4.26666667,6.04444444 L4.62222222,6.04444444 C4.81859435,6.04444444 4.97777778,5.88526204 4.97777778,5.68888889 L4.97777778,5.33333333 C4.97777778,5.13696018 4.81859435,4.97777778 4.62222222,4.97777778 L4.26666667,4.97777778 C4.07029216,4.97777778 3.91111111,5.13696018 3.91111111,5.33333333 Z",
    id: "Path",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 12.2666667,
    cy: 5.51111111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EFD358",
    cx: 12.2666667,
    cy: 5.51111111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4DA34D",
    cx: 12.2666667,
    cy: 7.64444444,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E86C60",
    cx: 13.3333333,
    cy: 6.57777778,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#458BC4",
    cx: 11.2,
    cy: 6.57777778,
    r: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryGamer);
export default __webpack_public_path__ + "static/media/category_gamer.eff1f2885c5ba9400fdd305de9dce162.svg";
export { ForwardRef as ReactComponent };